<!-- Don't touch elements that contains ids, cause they are used in unit test -->
<div class="container">
  <div ui-row>
    <div ui-col class="list-item mr-20px">
      <div class="mb-10px"><button id="btn-toggle-data" ui-button (click)="change()">Switch Data</button></div>
      <ui-list id="list-horizontal" uiItemLayout="horizontal" [uiDataSource]="data" [uiLoading]="loading" [uiNoResult]="'hmmm there is no data!!!'">
        <ui-list-item *ngFor="let item of data">
          <ui-list-item-meta uiAvatar="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" uiDescription="This is description sha-lala">
            <ui-list-item-meta-title>
              <strong>{{ item.title }}</strong>
            </ui-list-item-meta-title>
          </ui-list-item-meta>
        </ui-list-item>
        <ui-list-empty *ngIf="data.length === 0"></ui-list-empty>
      </ui-list>
    </div>

    <div ui-col class="list-card">
      <strong class="mb-10px">Responsive</strong>
      <ui-list id="list-grid" uiGrid>
        <div ui-row [uiGutter]="16">
          <div ui-col [uiXXl]="8" [uiXl]="4" [uiLg]="6" [uiMd]="6" [uiSm]="12" [uiXs]="24" *ngFor="let item of dataCard">
            <ui-list-item>
              <ui-card [uiTitle]="item.title">Card content</ui-card>
            </ui-list-item>
          </div>
        </div>
      </ui-list>
    </div>
  </div>
</div>
<div ui-row class="simple-list">
  <div ui-col>
    <ul ui-list id="list-simple" uiHeader="This is Header!" [uiFooter]="listSimpleFooter" [uiDataSource]="simpleData" uiBordered uiSize="large">
      <li ui-list-item *ngFor="let item of simpleData" uiNoFlex>
        <ul ui-list-item-actions>
          <ui-list-item-action>
            <a (click)="clickItem(item)">click (check console)</a>
          </ui-list-item-action>
        </ul>
        {{ item }}
      </li>
      <li ui-list-item id="list-item" uiNoFlex>
        <ul ui-list-item-actions>
          <ui-list-item-action>
            <a (click)="clickItem('The last one!')">click (check console)</a>
          </ui-list-item-action>
        </ul>
        This is the last item!
      </li>
    </ul>
  </div>
  <div ui-col>
    <ui-list class="demo-loadmore-list">
      <ui-list-item *ngFor="let item of moreData">
        <ng-container *ngIf="!item.loading">
          <ui-list-item-meta [id]="'lim-' + item.id" uiAvatar="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" uiDescription="I'll add some description here for the unit tests ;)">
            <ui-list-item-meta-title>
              <a href="https://ng.ant.design">{{ item.title }}</a>
            </ui-list-item-meta-title>
          </ui-list-item-meta>
        </ng-container>
        <ui-skeleton *ngIf="item.loading" [uiAvatar]="true" [uiActive]="true" [uiTitle]="false" [uiLoading]="true"></ui-skeleton>
      </ui-list-item>
      <div class="loadmore" ui-list-load-more>
        <button ui-button (click)="onLoadMore()">Gimme more</button>
      </div>
    </ui-list>
  </div>
  <ng-template #listSimpleFooter><strong>Footer</strong></ng-template>
</div>
